import { Directive, effect, inject, Input, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { CapabilitiesService } from '../services/capabilities.service';

/**
 * Mostra il contenuto solo se l'utente ha la capability indicata.
 *
 * Da usare quando il comando non compete mai a quel profilo. Se invece compete
 * ma non in questo momento, non nasconderlo: disabilitalo con
 * `capabilities.can(...)`, perche' un comando che sparisce e riappare a
 * seconda dello stato disorienta.
 */
@Directive({
  selector: '[uiCan]',
})
export class CanDirective {
  private readonly capabilities = inject(CapabilitiesService);
  private readonly template = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly capability = signal('');

  private visibile = false;

  @Input() set uiCan(capability: string) {
    this.capability.set(capability);
  }

  private readonly capabilityEffect = effect(() => {
    const consentito = this.capabilities.can(this.capability());

    if (consentito === this.visibile) {
      return;
    }

    this.viewContainer.clear();

    if (consentito) {
      this.viewContainer.createEmbeddedView(this.template);
    }

    this.visibile = consentito;
  });
}
